import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import { fetchAccountActivity } from '@/renderer/services/accountingReportingService';
import type { AccountingReportFilterParams } from '@/renderer/types/accounting';

export function useAccountActivity(
  params: AccountingReportFilterParams,
  enabled = true,
) {
  return useQuery({
    queryKey: queryKeys.accounting.accountActivity(params),
    queryFn: async () => {
      const result = await fetchAccountActivity(params);
      if (!result.success || !result.data) {
        throw new Error(result.error ?? 'Failed to fetch account activity');
      }
      return result.data;
    },
    enabled: !!params.companyId && enabled,
    placeholderData: keepPreviousData,
  });
}
